import format from "date-fns/format";
import { enUS } from "date-fns/locale";

import * as FN from "date-fns";

export const formatDate = (date: string, formatText: string): string => {
  const newDate: Date = new Date(date);
  const fnsDate: string = format(newDate, formatText, { locale: enUS });

  return fnsDate;
};


export const formatFromUtcDate = (date: string, formatText: string): string => {

	/*
	WILL TAKE AN UTC DATE, GENERATED SERVER SIDE, THAT LOOKS LIKE THIS:
	2022-06-10T18:08:21.163 
	(IT'S 18:08 UTC, 15:08 ARGENTINA, 14:08 EST)

	GET THE TIME ZONE OFFSET (WE ARE ON THE CLIENT SIDE)
	AND ADD IT TO THE ABOVE UTC DATE, WHICH WILL 
	RESULT IN THE RIGHT DATE, READY TO BE FORMATTED: 
	
	2022-06-10 15:08 (ARG)
	2022-06-10 14:08 (EST)
	*/

	/// THE OFFSET IS IN MINUTES.
	const tzOffset = new Date().getTimezoneOffset();
	
	const newDate: Date = new Date(date);

	/// ADDING THE OFFSET SO THE DATE LOOKS AS "LOCAL",
	/// TO ADD MINUTES, WE MULTIPLY BY 60000
	/// https://stackoverflow.com/a/70317779/1178368
	const modDate: Date = new Date(newDate.getTime() - (60000 * tzOffset) ); 

  const fnsDate: string = format(modDate, formatText, { locale: enUS });

  return fnsDate;
};



